/**
 * 身份证明号码验证验证
 */
export { fgId18Validate }

function fgId18Validate (value) {
  var cities = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外'
  }
  var weight = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] // 十七位数字本体码权重
  var validate = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'] // mod11,对应校验码字符值

  // 验证长度
  if (/^[^0-9]/.test(value)) {
    // 第一位不是数字，不进行居民身份证验证
    return true
  }

  if (/^8[1-3]/.test(value) && value.length === 18) {
    // 港澳台居民身份证验证
    return true
  }

  if (!/^\d{17}(\d|x)$/i.test(value)) {
    return false
  }
  // 验证省份
  if (!cities[Number(value.substr(0, 2))]) {
    return false
  }
  // 验证出生日期
  var birthday =
    value.substr(6, 4) + '-' + value.substr(10, 2) + '-' + value.substr(12, 2)
  var validBirthday = new Date(birthday)
  if (
    validBirthday.getFullYear() !== Number(value.substr(6, 4)) ||
    validBirthday.getMonth() + 1 !== Number(value.substr(10, 2)) ||
    validBirthday.getDate() !== Number(value.substr(12, 2))
  ) {
    return false
  }
  // 验证校验位
  var sum = 0
  var mode = 0
  for (var i = 0; i < 17; i++) {
    sum = sum + (value.split('')[i] - 0) * weight[i]
  }
  mode = sum % 11
  if (validate[mode] === value.split('')[17]) {
    return true
  }
  return false
}
